var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "return-reasons" },
    [
      _c(
        "el-select",
        {
          staticClass: "return-reason-select",
          attrs: {
            id: "return-reason-select-id",
            "popper-class": "return-reason-dropdown",
            placeholder: "Select return reason",
          },
          model: {
            value: _vm.selectedAllReason,
            callback: function ($$v) {
              _vm.selectedAllReason = $$v
            },
            expression: "selectedAllReason",
          },
        },
        _vm._l(_vm.returnReasons, function (reason) {
          return _c(
            "el-option",
            {
              key: reason.id,
              staticClass: "return-reason-option",
              attrs: { label: reason.text, value: reason.id },
            },
            [
              _c("span", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(reason.text)),
              ]),
              _vm._v(" "),
              _vm.selectedAllReason === reason.id && _vm.showAllCheckMark
                ? _c("span", { staticStyle: { float: "right !important" } }, [
                    _c("img", {
                      staticStyle: {
                        height: "12.28px",
                        width: "15.78px",
                        "padding-top": "5px",
                      },
                      attrs: {
                        src: require("../../../../assets/drop-down-checkmark.svg"),
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }